import { Model } from '@/models/Model';

export class Season extends Model {
  protected $name: string = 'Season';
  protected $endpoint: string = '/seasons';
  protected $fillable: string[] = [
    'name',
    'short_name'
  ];

  public name?: string;
  public short_name?: string;
  public id?: string;

  protected static instance?: Season;
  public static getInstance(instance: Season) {
    if (! this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }
}
